import {type RefObject} from "react";
import {css, cx} from "@panda/css";

import {Loader} from "@pg-design/loader-module";

import {useAppSelector} from "../../store/hooks";
import {SemanticSearchConversation} from "../components/semantic_search_conversation/SemanticSearchConversation";
import {SemanticSearchQuery} from "../components/semantic_search_query/SemanticSearchQuery";
import {SemanticSearchHeader} from "../components/SemanticSearchHeader";
import {useSemanticSearchLocalStorage} from "../hooks/use_semantic_search_local_storage";
import {selectSemanticSearchHasConversation} from "../state/select_semantic_search_has_conversation";

interface Props {
    containerRef?: RefObject<HTMLDivElement | null>;
}

export function SemanticSearchView({containerRef}: Props) {
    const {isLoading} = useSemanticSearchLocalStorage();
    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);

    return (
        <div className={cx(semanticSearchView, hasConversation ? semanticSearchViewWithConversation : semanticSearchViewEmpty)}>
            {isLoading && (
                <div className={loaderWrapper}>
                    <Loader size="xl" />
                </div>
            )}

            {!isLoading && (
                <>
                    {!hasConversation && <SemanticSearchHeader />}
                    {hasConversation && <SemanticSearchConversation containerRef={containerRef} />}
                    <SemanticSearchQuery hasStickySidebar={!!hasConversation} />
                </>
            )}
        </div>
    );
}

const semanticSearchView = css({
    display: "flex",
    flexDirection: "column",
    minHeight: "100dvh",
    background: "var(--colors-background-100)",
    position: "relative"
});

const semanticSearchViewWithConversation = css({
    justifyContent: "flex-start"
});

const semanticSearchViewEmpty = css({
    justifyContent: "center",
    alignItems: "center",
    background: "var(--colors-background-100)"
});

const loaderWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
});
import {type RefObject} from "react";
import {css, cx} from "@panda/css";

import {Loader} from "@pg-design/loader-module";

import {useAppSelector} from "../../store/hooks";
import {SemanticSearchConversation} from "../components/semantic_search_conversation/SemanticSearchConversation";
import {SemanticSearchQuery} from "../components/semantic_search_query/SemanticSearchQuery";
import {SemanticSearchHeader} from "../components/SemanticSearchHeader";
import {useSemanticSearchLocalStorage} from "../hooks/use_semantic_search_local_storage";
import {selectSemanticSearchHasConversation} from "../state/select_semantic_search_has_conversation";

interface Props {
    containerRef?: RefObject<HTMLDivElement | null>;
}

export function SemanticSearchView({containerRef}: Props) {
    const {isLoading} = useSemanticSearchLocalStorage();
    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);

    return (
        <div className={cx(semanticSearchView, hasConversation ? semanticSearchViewWithConversation : semanticSearchViewEmpty)}>
            {isLoading && (
                <div className={loaderWrapper}>
                    <Loader size="xl" />
                </div>
            )}

            {!isLoading && (
                <>
                    {!hasConversation && <SemanticSearchHeader />}
                    {hasConversation && <SemanticSearchConversation containerRef={containerRef} />}
                    <SemanticSearchQuery hasStickySidebar={!!hasConversation} />
                </>
            )}
        </div>
    );
}

const semanticSearchView = css({
    display: "flex",
    flexDirection: "column",
    minHeight: "100dvh",
    background: "var(--colors-background-100)",
    position: "relative"
});

const semanticSearchViewWithConversation = css({
    justifyContent: "flex-start"
});

const semanticSearchViewEmpty = css({
    justifyContent: "center",
    alignItems: "center",
    background: "var(--colors-background-100)"
});

const loaderWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
});
